import debounce from 'lodash.debounce';
import React, { useCallback, useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputProps } from 'reactstrap';

import { RenderInput, RenderInputProps } from './RenderInput';
import { DEFAULT_FILTERS_DEBOUNCE_TIMEOUT_IN_MS } from '../../constants';

export const finalFormDeBouncedInputHelper =
  (inputProps: InputProps & { dataTestId?: string; label?: string }, disabled?: boolean) =>
  (fieldRenderProps: FieldRenderProps<string>) =>
    (
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      <DeBouncedInput disabled={disabled} {...inputProps} {...fieldRenderProps} />
    );

export const DeBouncedInput: React.FC<RenderInputProps> = ({
  input: { onChange, value, ...restInputProps },
  ...props
}) => {
  const [isTyping, setTyping] = useState(false);
  const [tempValue, setTempValue] = useState(value);

  // reset state when form get reset
  if (!isTyping && tempValue && !value) {
    setTempValue('');
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateFormValue = useCallback(
    debounce((newValue: string) => {
      if (onChange) {
        onChange(newValue);
      }
      setTyping(false);
    }, DEFAULT_FILTERS_DEBOUNCE_TIMEOUT_IN_MS),
    []
  );

  const onChangeHandler = (newValue: string) => {
    /**
     * skip debounce when value was not changed by manual typing
     * (eq. changed by autocomplete, pasted from clipboard, etc)
     */
    if (!isTyping && Math.abs(newValue.length - tempValue.length) > 1) {
      setTempValue(newValue);
      onChange(newValue);
      return;
    }

    setTempValue(newValue);
    setTyping(true);
    updateFormValue(newValue);
  };

  return <RenderInput {...props} input={{ onChange: onChangeHandler, value: tempValue, ...restInputProps }} />;
};
